import { mapGetters } from 'vuex';

export const useStore = ( options: Record<string, any> = {}): Readonly<{
    get: ( id: any, defaultValue?: any ) => any;
    set: ( id: string, value: any ) => void;
    del: ( id: any ) => void;
    clear: () => void;
}> => {

    let _cache: Record<string, any> = {};

    const setValue = ( id: string, value: any ): void => {

        if ( options.cover ) {

            _cache[id] = value;
            return;

        }
        if ( id in _cache ) {

            return;

        }
        _cache[id] = value;

    };

    const getValue = ( id: string, defaultValue?: any ): any => {

        if ( id in _cache ) {

            return _cache[id];

        }
        if ( void 0 !== defaultValue ) {

            _cache[id] = defaultValue;

            return defaultValue;

        }
        return null;

    };

    const clear = (): void => {

        _cache = {};

    };

    const deleteValue = ( id: string ): void => {

        delete _cache[id];

    };

    return Object.freeze({
        get: getValue,
        set: setValue,
        del: deleteValue,
        clear
    });

};
